import { useLocation } from '@react-router';
import qs from 'query-string';
export function useQueryParams(options?: qs.ParseOptions) {
  const search = useLocation().search;
  return qs.parse(search, options);
}
